import React, { Fragment, ReactNode } from 'react'
import { get, map } from 'lodash'
import { Box } from 'front-end/src/components'
import ListFooter from './ListFooter'
import Loader from '../loader/Loader'
import classNames from 'classnames'
import { BoxProps } from '@chakra-ui/react'

import './List.less'

export interface ListProps<Item> {
  className?: string
  keyPath?: string
  items: Item[]
  itemsCount?: number | null
  renderItem: (item: Item, idx?: number) => ReactNode
  page?: number
  pageSize?: number
  loading?: boolean
  showFooter?: boolean
  actions?: ReactNode
  header?: ReactNode
  emptyState?: ReactNode
  onPageChange?: (page: number) => void
}

export const ItemList: React.FC<ListProps<any> & BoxProps> = (props) => {
  const {
    className,
    keyPath,
    items,
    itemsCount,
    renderItem,
    page,
    pageSize,
    loading,
    actions,
    header,
    showFooter,
    emptyState,
    onPageChange,
    ...rest
  } = props

  const renderListContent = () => {
    if (loading) {
      return <Loader />
    }

    return (
      <>
        <div className="ListItems">
          {map(items, (item, idx) => (
            <Fragment key={get(item, keyPath ?? 'id', idx)}>
              {renderItem(item, idx)}
            </Fragment>
          ))}
        </div>
        {showFooter !== false && (
          <ListFooter
            itemsCount={itemsCount ?? 0}
            actions={actions}
            page={page}
            pageSize={pageSize}
            onPageChange={onPageChange}
          />
        )}
      </>
    )
  }

  return (
    <Box mt="16px" className={classNames('List', className)} {...rest}>
      {header && <div className="ListHeader">{header}</div>}
      {renderListContent()}
    </Box>
  )
}
